const e = {
  otherSuggestions: "other suggestions available"
};
export {
  e as default
};
